
import Legend, { ILegendProps } from './Legend';
import Dialog from '../../BaseComponents/Dialog/EDDialog';
import { makeStyles } from 'tss-react/mui';

export interface ILegendMenuProps extends ILegendProps {
  menuRef: React.MutableRefObject<any>;
  open: boolean;
  toggleOpen: () => void;
}

const useStyles = makeStyles()({
  contentWrapper: {
    margin: 0,
  },
} as const);

const LegendMenu: React.FC<
  React.PropsWithChildren<ILegendMenuProps>
> = props => {
  const { classes } = useStyles();
  return props.posts.length > 0 ? (
    <Dialog
      open={props.open}
      onClose={props.toggleOpen}
      title="Färger och betydelser"
      footerActions={[
        {
          label: 'Stäng',
          onClick: props.toggleOpen,
        },
      ]}
      classes={{ contentWrapper: classes.contentWrapper }}
    >
      <Legend {...props} />
    </Dialog>
  ) : null;
};

export default LegendMenu;
